import { DuringContractListPage } from "@/features/rso/pages/DuringContractList";
import React from "react";

const DuringContractList = () => {
  return <DuringContractListPage />;
};

export default DuringContractList;
